var version = {
    "name":      "dativery",
    "buildDateCode": "20250410-160044",
    "buildDate": "Thu Apr 10 2025 16:00:44 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20250410-160044",
    "backupUIVersion": "2.2.0-20250409-180038"
}
;
 export default version;